import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";

// Lazy load routes for code splitting and reduced initial bundle size
const Dashboard = lazy(() => import("./pages/Dashboard"));
const CreatePresentation = lazy(() => import("./pages/CreatePresentation"));
const UploadContent = lazy(() => import("./pages/UploadContent"));
const Presenter = lazy(() => import("./pages/Presenter"));
const Analytics = lazy(() => import("./pages/Analytics"));
const Viewer = lazy(() => import("./pages/Viewer"));
const Login = lazy(() => import("./pages/Login"));

// Loading component
const LoadingFallback = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <div>Loading...</div>
  </div>
);

function App() {
  const [user, setUser] = React.useState(() => {
    const saved = localStorage.getItem("user");
    return saved ? JSON.parse(saved) : null;
  });

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  return (
    <Router>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route
            path="/login"
            element={
              user ? (
                <Navigate to="/" replace />
              ) : (
                <Login onLogin={handleLogin} />
              )
            }
          />
          <Route
            path="/"
            element={
              user ? (
                <Dashboard user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/create"
            element={
              user ? (
                <CreatePresentation user={user} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/presentation/:id/edit"
            element={
              user ? (
                <CreatePresentation user={user} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/presentation/:id/upload"
            element={
              user ? (
                <UploadContent user={user} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/presenter/:presentationId"
            element={
              user ? (
                <Presenter user={user} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/analytics"
            element={
              user ? (
                <Analytics user={user} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route path="/viewer/:viewerToken" element={<Viewer />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
